// src/setup.ts
var legacyRestApiUrl = null;
var legacyRestApi = {
  init(url) {
    if (!url) {
      throw Error(
        "You must provide a url parameter when initializing legacyRestApi "
      );
    }
    if (legacyRestApiUrl) {
      console.warn(`leagueApi has already been initialized with ${url}.`);
    }
    if (!legacyRestApiUrl)
      legacyRestApiUrl = url;
  },
  getLegacyRestApiUrl() {
    return legacyRestApiUrl;
  }
};
Object.freeze(legacyRestApi);
export {
  legacyRestApi
};
//# sourceMappingURL=index.js.map